import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { CompanyWarehouseAccess } from 'contracts/CompanyWarehouseAccesses';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'FETCH_COMPANY_WAREHOUSE_ACCESS_',
  }
);

export interface FetchCompanyWarehouseAccessState {
  data: CompanyWarehouseAccess | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchCompanyWarehouseAccessRequestAction {
  id: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: CompanyWarehouseAccess;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchCompanyWarehouseAccessState = {
  data: null,
  loading: false,
  errorMessage: null,
};

const request = (state: FetchCompanyWarehouseAccessState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (
  state: FetchCompanyWarehouseAccessState,
  action: SuccessAction
) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (
  state: FetchCompanyWarehouseAccessState,
  action: FailureAction
) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: FetchCompanyWarehouseAccessState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const fetchCompanyWarehouseAccess = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const FetchCompanyWarehouseAccessTypes = Types;
export const FetchCompanyWarehouseAccessActions = Creators;
